import { SagaContext } from 'async-saga';
import dayjs from 'dayjs';
import { AnyAction, Dispatch } from 'redux';
import { actions } from '..';
import { redirectToLogout } from '../..';
import { commandReceived, getDeviceGroups, getExtensionsByIds, parseJson, parseMsDate, parseStringDate, requestOpenBookItWindow, secondsToTimestamp } from '../../api';
import { createJitsiCallResponse } from '../../api/call-control';
import { getContactsByIds } from '../../api/contact-control';
import * as apiQueue from '../../api/queue-control';
import { getQueueMode } from '../../api/queue-control';
import { CallBookmarkRaw, callTranscriptionUnSubscribe, callTranscriptionValidate, getCallTranscriptionCall, TranscriptionCallRaw, TranscriptionParagraphRaw } from '../../api/transcriptions';
import { getUtcNow } from '../../Components/AgentsTable';
import { replaceScriptingVars } from '../../Components/AgentView/MediaPage';
import { getCommandIdFromCommand } from '../../Components/CallPopup';
import { toObject } from '../../data-utils';
import { showConfirmWindow, teamsShowJoinConferenceDialog } from '../../legacy';
import { AgentKey, AgentStatistic, BasicNotification, Call, CallDeviceType, CallFolder, CallState, CallSuppressType, CallType, Command, ConversationFlags, ConversationMessage, DeviceGroup, DeviceGroupDestinationTypes, DeviceType, EntityType, FacebookComment, FacebookPost, Identifier, InstantMessageConversationParticipant, InstantMessageConversationRecipent, InstantMessagerJoinState, Media, MediaType, QueueIconEnum, QueueMode, QueueRegionId, sameIdentifier, Shortcut, SquadId, VoiceMailFolder } from '../../model';
import { createPromiseSource } from '../../promise-utils';
import pushUpdates from '../../push-updates';
import { Mutable } from '../../type-utils';
import { MessageType, ucBool } from '../../uc-messaging';
import { selectActiveDevice } from '../reducers';
import { selectHaveCallback } from '../reducers/callback';
import { selectMediaCommand } from '../reducers/command';
import { getConfig, selectConfigProp, selectCurrentDeviceGroup, selectFavContactFolderId, selectFavExtensionFolderId, selectFavQueueFolderId, selectMyAccess, selectMyData, selectMyDevices, selectMyRegion, selectMyself, selectShortcutFolderId } from '../reducers/config';
import { selectFacebookByPostId, selectFacebookByUserId } from '../reducers/facebook';
import { getInstantMessageById } from '../reducers/instantmessager';
import { getParkedMedia, selectInIpfxClient, selectInIpfxMobility, selectSelectedQueueView } from '../reducers/localSettings';
import { getForAutoAnswer, selectHeldCall, selectMedia, selectMyActiveCall, selectMyMedia, shouldFetchMediaQueueInfo } from '../reducers/media';
import { getNow } from '../reducers/now';
import { selectExtension } from '../reducers/queueAgents';
import { selectMyQueues } from '../reducers/queues';
import { JitsiResult } from '../reducers/settings';
import { getTranscriptions, hasTranscription, transcriptionLoaded } from '../reducers/transcriptions';
import { take, waitForState } from '../tools/async-saga-types';
import { StoreState } from '../types';

enum TeamsClientControlCtiAction {
  Quit,
  TeamsClientIntegratedMode,
  TeamsClientBasicMode,
  TeamsClientIntegratedEnabled,
  TeamsClientIntegratedDisabled
}

export enum DBAction {
  Create = 1,
  Update = 3,
  Delete = 4,
  Query = 5,
}


/*
function createActionBatcher<TType extends string, TPayload>(ac: (...args: any[]) => PayloadAction<TType, TPayload>, getKey: (payload: TPayload) => string, delay = 1000) {
  const batch: PayloadAction<TType, TPayload>[] = []

  const fn = debounce(function (dispatch: Dispatch) {
    let updates = batch.splice(0)
    const newUpdates = Object.values(toObject(updates, a => getKey(a.payload), x => x));
    console.warn(updates[0].type, updates.length, newUpdates.length)
    updates = newUpdates
    for (const update of updates) {
      dispatch(update)
    }
  }, delay)

  return function (dispatch: Dispatch, action: PayloadAction<TType, TPayload>) {
    batch.push(action)
    fn(dispatch)
  }
}
*/
//const updateQueue = createActionBatcher(actions.updateQueue, getKey)
//const updateExtensionStatus = createActionBatcher(actions.updateExtensionStatus, x => getKey(x.extension))
//const setQueueIcon = createActionBatcher(actions.setQueueIcon, x => getKey(x.queue))

const Handlers: { [type: number]: (ctx: SagaContext<StoreState>, records: string[][]) => void | Promise<void> } = {
  [MessageType.BROADCAST_HEARTBEAT_EVENT]({ dispatch }) {
    dispatch(actions.pong())
  },

  [MessageType.RESPONSE_CLIENT_EVENTS]({ dispatch, getState }, [[connection, error, blockMessageInLocation, allowBlockedMessagesSentAsEmails, socketId]]) {
    if (connection === "0") {

      dispatch(actions.showNoLicensesAvailable(true))
    } else {
      dispatch(actions.setSocketId(socketId))
      dispatch(actions.instantMessagerSettingsUpdate(undefined, allowBlockedMessagesSentAsEmails.toLowerCase() === 'true', blockMessageInLocation.toLowerCase() === 'true'))
    }
  },

  [MessageType.BROADCAST_CONNECTION_STATE]({ dispatch, getState }, [[connectedState]]) {
    // connectedState === '1' == connected
    console.info('ipfx server has ' + connectedState === '1' ? 'connected' : 'dissconnected')
  },

  [MessageType.BROADCAST_CALL_STATUS_TASKED]({ dispatch, getState }, [[mediaId, taskId]]) {
    //need to add taskId to media then we can use as an idicator that it's been tasked
    dispatch(actions.setMediaTaskId(mediaId, taskId))
  },

  async [MessageType.BROADCAST_CALL_STATUS]({ dispatch, getState }, [[server, deviceId, callId, status, clid,
    clidDescription, connectedParty, queue, dnis, dnisDescription, extensionFullName, elapsedTime,
    objectType, wrapupFolder, preferredExtn, forwardFrom, forwardReason, callType, isQueueCall, deviceType,
    recordStatus, reason, notes, urgency, extensionId, extentionDeviceDescription, queuingSeconds, forwardFromSource, subject,
    extensionsWaitingForWrapupText, callTransactionId, heldSeconds, talkSeconds, wrapupSeconds, inVmRecordingMessage, preferredExtnDescription, clidAccountCode,
    clidNumberType, sourceApp, clidObjectKey, clidObjectType, mediaItemId, extensionEmail, queueIdDescription],
    ...devices]) {

    const store = getState()
    const myDevicves = selectMyDevices(store)
    const myId = selectMyself(store)
    const parked = getParkedMedia(store)
    const region = selectMyRegion(store)
    const config = selectMyData(store)
    const access = selectMyAccess(store)
    const heldCall = selectHeldCall(store)
    const extension = myId && selectExtension(store, myId)

    //not interested unless you are logged in
    if (!myDevicves || !myId || !region || !config || !access || !extension) { return }

    const isRecording = false, voicemailPort = '', voicemailPortIsConnected = false,
      voicemailPortIsSuppresed: CallSuppressType = 'allowed',
      hide: boolean = false,
      taskId = '', minimised: number = 0, dtmf: boolean = false

    const media: Media = {
      id: callId,
      deviceId,
      status: parseInt(status),
      clid,
      clidDescription,
      connectedParty,
      queueId: queue,
      queueIdDescription: queueIdDescription,
      server,
      dnis,
      dnisDescription,
      fullName: extensionFullName,
      elapsedTime: secondsToTimestamp(parseInt(elapsedTime)), //changed by status of call i.e. hold time if on hold, talk time if answered etc
      mediaType: objectType as MediaType,
      wrapupFolder: wrapupFolder,
      preferredExtn: preferredExtn,
      forwardFrom: forwardFrom,
      forwardReason: parseInt(forwardReason),
      callType: parseInt(callType),
      isQueueCall: isQueueCall === "1",
      deviceType: parseInt(deviceType),
      recordStatus: parseInt(recordStatus),
      reason,
      notes,
      urgency: parseInt(urgency),
      extensionId,
      deviceDescription: extentionDeviceDescription,
      queuingTime: parseInt(queuingSeconds),
      subject,
      extensionsWaitingForWrapup: extensionsWaitingForWrapupText.split(",").filter(x => x),
      callTransactionId: callTransactionId,
      heldTime: parseInt(heldSeconds),
      talkTime: parseInt(talkSeconds),
      wrapupTime: parseInt(wrapupSeconds),
      inVmRecordingMessage: inVmRecordingMessage === "1",
      preferredExtnDescription,
      clidAccountCode,
      clidNumberType: parseInt(clidNumberType),
      clidObjectKey,
      clidObjectType: parseInt(clidObjectType),
      sourceApp,
      lastUpdateTime: Date.now(),
      isRecording,
      voicemailPort,
      voicemailPortIsConnected,
      voicemailPortIsSuppresed,
      hide,
      minimised,
      taskId,
      mediaItemId,
      extensionEmail,
      devices: devices.map(([number, baseType, description, visible]) => ({
        number: number.toLowerCase(),
        baseType: parseInt(baseType),
        description,
        visible: visible === '1',
      })),
      dtmf,
      window: false,
    }

    if (access.isTeamsPbx && media.deviceType === CallDeviceType.Other) {
      if (media.callType !== CallType.Queue && media.callType !== CallType.Callback) {
        // actually we are interested if 
        // out going email or
        // outgoing call and we have another on hold (i.e. sup transfer)
        if (media.callType === CallType.Outgoing && media.mediaType === 'EMAIL') {
          //let's process this 
        } else if (media.callType === CallType.Outgoing && (media.mediaType === 'CALL' || media.mediaType === 'VM') && heldCall !== null && heldCall.id !== media.id) {
          //let's process this
        } else {
          return
        }
      }
    }

    //park hack to make calls work as expected
    if (parked.length > 0 && parked.find(id => id === media.id)) {
      //if (media.isQueueCall) {
      if (media.deviceId !== "" && !myDevicves.devices.find(d => d.number === media.deviceId)) {
        if (media.status !== CallState.ExtensionAnswered) {
          console.info("BROADCAST_CALL_STATUS NOT PROCESSED NO DEVICE ID Id[" + media.id + "] Status[" + media.status + "] ClidObjectKey[" + media.clidObjectKey + "] ClidObjectType[" + media.clidObjectType + "] ")
          return;
        }
      }
      //}
    }

    const key: Mutable<AgentKey> = {
      server,
      queue,
      agent: extensionId,
    }

    const key1: Mutable<AgentKey> = ({} as AgentKey)
    key1.agent = ''

    if (!ucBool(isQueueCall)) {
      //do not simplify
      if ((media.status === CallState.CallInVoicemail || media.status === CallState.QueueHold) &&
        (myDevicves.devices.find(x => x.number === queue) || myDevicves.devices.find(x => x.number === forwardFrom))) {
        key.queue = myId.id
      } else {
        key.queue = extensionId
      }
      key.agent = null
    }

    if (media.mediaType !== "CALL" && media.mediaType !== "VM") {
      if (media.status !== CallState.ExtensionAnswered && media.status !== CallState.ExtensionPending && media.status !== CallState.Queueing && media.status !== CallState.WaitingForWrapup && media.status !== CallState.QueueHold) {
        console.info("BROADCAST_CALL_STATUS NOT PROCESSED Id[" + media.id + "] Queue[" + key.queue + "] Agent[" + key.agent + "] Status[" + media.status + "] ClidObjectKey[" + media.clidObjectKey + "] ClidObjectType[" + media.clidObjectType + "] ")
        return
      }
    }

    //console.info("BROADCAST_CALL_STATUS Id[" + media.id + "] Queue[" + key.queue + "] Agent[" + key.agent + "] Status[" + media.status + "] ClidObjectKey[" + media.clidObjectKey + "] ClidObjectType[" + media.clidObjectType + "] ")
    dispatch(actions.updateMedia(media, myId, parked))

    // check this url has been launched might
    if (ucBool(isQueueCall) && myId.id === key.agent && media.status === CallState.ExtensionAnswered) {
      if (shouldFetchMediaQueueInfo(getState(), media.id)) {
        const queue = await apiQueue.getQueueDetails(media.queueId)
        dispatch(actions.updateMediaQueueInfo(media.id, queue.forcedWrapup))

        if (queue.launchURIOnAnswer && queue.uRITarget) {
          dispatch(actions.openWindowInUrl(media.id, replaceScriptingVars(queue.uRITarget, media, config, region)))
        }
      }
    }

    // need to always load transcriptions due to another hack that requires the client to complete if transcription 
    // remember this could  of a refresh for wrapup, invoicemail etc
    if (((ucBool(isQueueCall) && myId.id === key.agent) || (key.queue === extensionId && myId.id === key.queue)) && media.status === CallState.ExtensionAnswered) {
      const load = transcriptionLoaded(getState(), media.id)
      if (!load) {
        //load transcription
        dispatch(actions.fetchCallTranscriptionRequest(media.id))
      }
    }
  },

  [MessageType.BROADCAST_CALL_NOTE_UPDATED]({ dispatch, getState }, [[json]]) {
    const message = JSON.parse(json) as RawBroadcastCallNoteUpdated
    dispatch(actions.setMediaNotes(message.CallId, message.Notes))
  },

  [MessageType.ResponseGetLocation]({ dispatch, getState }, [[extension, server, firstName, lastName, office, presence, returnTime, status, department, deviceType, callCenterAgent, isWrapup, serverKey, statusReason, regionId, tempLogout, awayFromDesk, breakCode, title, mobile, email, canReceiveVoicemail, operatorNote, businessNumber, otherNumber, homeNumber, associatedNumber, pagerNumber]]) {
    dispatch(actions.updateExtensionDetails({ id: extension, server }, firstName, lastName, office, parseInt(presence), returnTime, parseInt(status), department, parseInt(deviceType), callCenterAgent === '1', isWrapup === '1', parseInt(statusReason), regionId, tempLogout === '1', awayFromDesk === '1', parseInt(breakCode), title, mobile, email, canReceiveVoicemail === '1', operatorNote, businessNumber, otherNumber, homeNumber, associatedNumber, pagerNumber))
  },

  [MessageType.BROADCAST_CALL_STATUS_TERMINATE]({ dispatch, getState }, [[id, deviceNumber, deviceToken]]) {
    const store = getState()
    const media = selectMedia(store, id)
    const transcription = hasTranscription(store, id)
    const devices = selectMyDevices(store)
    const myId = selectMyself(store)
    const parked = getParkedMedia(store)
    const transcriptionEnabled = selectConfigProp(store, 'transcriptionEnabled')
    const conversation = media && getInstantMessageById(store, media.mediaItemId)

    console.info("BROADCAST_CALL_STATUS_TERMINATE key id[" + id + "] deviceNumber[" + deviceNumber + "]")

    if (!media || !devices || !myId) { return }

    if (media.queueId !== deviceNumber) {
      // if deviceNumber matches one of the extensionsWaitingForWrapup (and it's not the last one
      // in that list) - remove the extension from the list instead of removing the whole media
      if (media.extensionsWaitingForWrapup.includes(deviceNumber)) {
        dispatch(actions.updateMedia({ ...media, extensionsWaitingForWrapup: media.extensionsWaitingForWrapup.filter(x => x !== deviceNumber) }, myId, parked))
      }

      if (devices.devices.find(d => d.number === deviceNumber)) {
        //remove command if terminate for my device
        const command = selectMediaCommand(store, id);
        if (command) {
          const id = getCommandIdFromCommand(command)

          dispatch(actions.removeCommand(id))
        }
      }

      return
    }

    //if we have a valid trasncription then the user must complete to remove from UI
    if (transcription) {
      if (media.status !== CallState.None && !media.completed) {
        dispatch(actions.updateMediaStatus(id, CallState.None))
        return
      }

      //if multiple terminates then we hit here 
      if (!media.completed)
        return
    }

    //if we have a valid conversation then the user must complete to remove from UI
    if (conversation) {
      if (media.status !== CallState.None && !media.completed) {
        dispatch(actions.updateMediaStatus(id, CallState.None))
        return
      }

      //if multiple terminates then we hit here 
      if (!media.completed)
        return
    }

    dispatch(actions.removeMedia(id))

    //clean up associate data
    cleanup(media)

    function cleanup(media: Media) {
      //clean up
      if (media) {
        dispatch(actions.removeMediaItem(media.mediaItemId))
        dispatch(actions.removeMediaItem(media.id))

        if (transcriptionEnabled === true) {
          callTranscriptionUnSubscribe(media.id)
        }
        if (media.mediaType === 'TC') {
          dispatch(actions.requestLeaveConversation(media.mediaItemId))
        }
      }

      const command = selectMediaCommand(store, id);
      if (command) {
        const id = getCommandIdFromCommand(command)

        dispatch(actions.removeCommand(id))
        dispatch(actions.removeMediaItem(id))
      }
    }
  },

  [MessageType.BROADCAST_QUEUE_STATS_EVENT]({ dispatch }, [, ...status]) {
    const data: QueueUpdate[] = status.map(([server, extension, iconId, Description, RouteType, RouteToStringLong, VirtualQueue, QueueItemsCount, QueueItemsLongestQueueTimeSeconds, AgentsLoggedIn, AnsCount, AbnQCount, OtherCount, ServiceLevelText, , , AlertTime, AlertCount, WarningTime, WarningCount, AnsQTimeTotal, AbnQTimeTotal]) =>
    ({
      icon: parseInt(iconId),
      id: extension,
      server: server,
      description: Description,
      mode: getQueueMode(parseInt(RouteType)),
      status: RouteToStringLong,
      count: parseInt(QueueItemsCount),
      time: parseInt(QueueItemsLongestQueueTimeSeconds) === 0 ? null : secondsToTimestamp(parseInt(QueueItemsLongestQueueTimeSeconds)),
      agents: parseInt(AgentsLoggedIn),
      answer: parseInt(AnsCount),
      abandoned: parseInt(AbnQCount),
      other: parseInt(OtherCount),
      agentStatus: Math.round(parseInt(ServiceLevelText)),
      virtual: VirtualQueue === 'True',
      ansQTimeTotal: parseInt(AnsQTimeTotal),
      abnQTimeTotal: parseInt(AbnQTimeTotal),
    }))

    data.forEach(d => {
      dispatch(actions.updateQueue(d.icon, d.id, d.server, d.description, d.mode, d.status, d.count, d.time, d.agents, d.answer, d.abandoned, d.other, d.agentStatus, d.virtual, d.ansQTimeTotal, d.abnQTimeTotal))
    });
  },

  [MessageType.BroadcastMediaItemsQueuHeld]({ dispatch }, [[parkedMedia]]) {
    dispatch(actions.setParkedMedia(parkedMedia.split(",").filter(x => x)))
  },

  [MessageType.BROADCAST_QUEUE_WARNING_BROADCAST]({ dispatch }, [[server, extension, , , warningType]]) {
    //if warningType === -1 don't do anything

    // warningType == 1 turn background red and change Icon to red
    // warningType == 0 turn background yellow and change Icon to yellow

    let icon: QueueIconEnum

    switch (warningType) {
      case '-1':
        return

      case '0':
        icon = QueueIconEnum.OpenWarning
        break

      case '1':
        icon = QueueIconEnum.OpenAlert
        break

      default:
        console.error(`Unknown queue warningType '${warningType}'`)
        return

    }

    dispatch(actions.setQueueIcon({ server, id: extension, type: 'queue' }, icon))
  },


  [MessageType.BROADCAST_QUEUE_WARNING_POP_BROADCAST]({ dispatch }, [[server, extension, , warningFlags, warningType]]) {
    // warningType === -1 then warning has stopped
    // warningFlags bit wise
    // (warningFlags & 4) == 4 && warningType == 0 alert (yellow)
    // (warningFlags & 8) == 8 && warningType == 1 alert (red)
    // (warningFlags & 1) == 1 && warningType == 0 beep
    // (warningFlags & 2) == 2 && warningType == 1 beep


    //if warningType equals -1 don't do anything
    // warningType == 1 turn background red and change Icon to red
    // warningType == 0 turn background yellow and change Icon to yellow

    let icon: QueueIconEnum

    switch (warningType) {
      case '-1':
        return

      case '0':
        icon = QueueIconEnum.OpenWarning

        if ((parseInt(warningFlags) & 4) !== 4) {
          return;
        }
        break

      case '1':
        icon = QueueIconEnum.OpenAlert

        if ((parseInt(warningFlags) & 8) !== 8) {
          return;
        }
        break

      default:
        console.error(`Unknown queue warningType '${warningType}'`)
        return

    }

    dispatch(actions.setQueuePopIcon({ server, id: extension, type: 'queue' }, icon))
  },

  [MessageType.BROADCAST_QUEUE_AGENTSTATS]({ dispatch }, [[queue, extension, answered, talkSeconds, server]]) {
    dispatch(actions.updateAgentStats({ server, queue, agent: extension }, parseInt(answered), parseInt(talkSeconds)))
  },

  async [MessageType.BROADCAST_QUEUE_AGENT_UPDATE](ctx, [[queue, id, enabled, access, skill, entryTime, entryCount, server]]) {
    const store = ctx.getState()

    let extension = selectExtension(store, { id, server: server })
    if (!extension) {
      ctx.dispatch(actions.fetchExtensionsByIds([{ id, server: server }]))

      await waitForState(ctx, s => selectExtension(s, { id, server: server }) !== undefined)
    }

    ctx.dispatch(actions.updateAgentInfo({ server, queue, agent: id }, enabled === "1", parseInt(access), parseInt(skill), parseInt(entryTime), parseInt(entryCount)))

    const myId = selectMyself(store)
    const view = selectSelectedQueueView(store)
    const myQueues = selectMyQueues(store)

    if (!myId || !view || !myQueues) return

    //relaod my queues
    if (myId.server === server && id === myId.id && myQueues.findIndex(q => q.id === queue) === -1) {
      if (view.region === QueueRegionId.Mine) {
        ctx.dispatch(actions.fetchQueues.request({ region: view.region, refresh: true }))
      }
      ctx.dispatch(actions.fetchMyQueues.request())
    }
  },

  [MessageType.BroadcastQueueExtensionRemove]({ getState, dispatch }, [[json]]) {
    const data = parseJson<BroadcastQueueExtensionRemove>(json)
    dispatch(actions.removeAgentInfo({ server: data.header.from.remoteServerName, queue: data.queueId, agent: data.extensionNumber }))

    const store = getState()
    const myId = selectMyself(store)
    const view = selectSelectedQueueView(store)
    if (!myId) return

    //relaod my queues
    if (myId.server === data.header.from.remoteServerName && data.extensionNumber === myId.id) {
      if (view.region === QueueRegionId.Mine) {
        dispatch(actions.fetchQueues.request({ region: QueueRegionId.Mine, refresh: true }))
      }
      dispatch(actions.fetchMyQueues.request())
    }
  },

  [MessageType.RESPONSE_EXTENSIONSTATE_EVENT]({ dispatch }, [[server, extension, status, subStatus, connectedParty, dnis]]) {
    dispatch(actions.updateExtensionStatus({ server, id: extension }, parseInt(status), parseInt(subStatus)))
  },

  [MessageType.RESPONSE_EXTENSIONLOCATION_EVENT]({ getState, dispatch }, [[server, extension, presence, returnTime, breakcodeValue, deviceGroupType, breakcode, , , , startTime]]) {
    //breakcodeValue this is the discription of the breakcode
    //startTime is utc
    //returnTime is in local server time
    const state = getState()
    const myRegion = selectMyRegion(state)
    const offset = selectConfigProp(state, 'localServerTimeZoneBias')
    let startTimeDate = dayjs(parseStringDate(startTime))
    if (!myRegion || offset === null || offset === undefined) {
      console.warn('No region or offset defined in config', state, myRegion, offset)
      return
    }

    const parsedReturnTime = parseStringDate(returnTime)
    const returnTimeDate = parsedReturnTime ? dayjs(parsedReturnTime).valueOf() : undefined
    dispatch(actions.updateExtensionPresence({ server, id: extension }, parseInt(presence), parseInt(breakcode), parseInt(deviceGroupType), returnTimeDate, startTimeDate.valueOf()));
  },

  [MessageType.RESPONSE_EXTENSIONAWAYFROMDESK_EVENT]({ dispatch }, [[server, extension, awayFromDesk]]) {
    dispatch(actions.updateExtensionAwayFromDesk({ server, id: extension }, awayFromDesk === "1"));
  },

  [MessageType.RESPONSE_EXTENSIONTEMPLOGOUT_EVENT]({ dispatch }, [[server, extension, tempLogout]]) {
    dispatch(actions.updateExtensionTempLogout({ server, id: extension }, tempLogout === "1"));
  },

  [MessageType.BROADCAST_WAITING_FOR_WRAPUP]({ dispatch }, [[server, extension, waitingForWrapup]]) {
    dispatch(actions.updateExtensionWaitingForWrapup({ server, id: extension }, waitingForWrapup === "1"));
  },

  [MessageType.NotifyUpsertedActivity]({ dispatch }, [[json]]) {
    const message = parseJson<RawNotifyUpsertedActivity>(json)
    dispatch(actions.updateExtensionAddActivity({ server: message.header.from.remoteServerName, id: message.activity.extension }, message.activity.activityId));
  },

  [MessageType.NotifyDeletedActivity]({ dispatch }, [[json]]) {
    const message = parseJson<RawNotifyDeletedActivity>(json)
    dispatch(actions.updateExtensionRemoveActivity({ server: message.header.from.remoteServerName, id: message.extension }, message.activityId));
  },

  async [MessageType.BROADCAST_UPDATE_EXTENSION_DEFAULTDEVICEGROUP]({ dispatch, getState }, [[extension, server, defaultDeviceGroupId, currentDeviceGroupId, currentDeviceGroupType]]) {
    const store = getState()
    const me = selectMyself(store)
    //if myself
    if (me && sameIdentifier(me, { server, id: extension })) {
      const deviceGroupsRequest = await getDeviceGroups(server, extension)
      const deviceGroups = deviceGroupsRequest[1]

      const currentDeviceGroup = selectCurrentDeviceGroup(store)
      const extensionDevices = selectMyDevices(store)
      const extensionData = selectMyData(store)

      //if not there then don't worry
      if (extensionData !== null && extensionData && currentDeviceGroup) {

        let group: DeviceGroup | null = null
        if (currentDeviceGroup && currentDeviceGroup.deviceGroupId !== currentDeviceGroupId) {
          for (let x = 0; x < deviceGroups.length; x++) {
            if (deviceGroups[x].deviceGroupId === currentDeviceGroupId) {
              group = deviceGroups[x];
              x = deviceGroups.length
            }
          }

          let number = extension
          if (extensionDevices) {
            if (group) {

              switch (group.playBackDevice) {
                case DeviceGroupDestinationTypes.Other:
                  number = extensionData.other;
                  break;
                case DeviceGroupDestinationTypes.MobilePhone:
                  number = extensionData.mobile;
                  break;
                case DeviceGroupDestinationTypes.Home:
                  number = extensionData.home;
                  break;
                case DeviceGroupDestinationTypes.Softphone:
                  if (extensionDevices != null) {
                    for (let x = 0; x < extensionDevices.devices.length; x++) {
                      if (extensionDevices.devices[x].baseType === DeviceType.Softphone) {
                        number = extensionDevices.devices[x].number;
                        x = extensionDevices.devices.length
                      }
                    }
                  }
                  break;
                case DeviceGroupDestinationTypes.Office:
                default:
                  {
                    number = extensionData.office;
                  }
              }
              // current device group
              dispatch(actions.updateCurrentDeviceGroup(group))
            }

            //sometimes there is no number set on device group
            if (number === "") {
              number = extension
            }

            for (let x = 0; x < extensionDevices.devices.length; x++) {
              if (extensionDevices.devices[x].number === number) {
                dispatch(actions.updatePrimaryDevice(number))
              }
            }
          }
        }
      }
    }

    dispatch(actions.updateExtensionDeviceGroupType({ server, id: extension }, parseInt(currentDeviceGroupType)))
  },

  async [MessageType.REQUEST_COMMAND](ctx, [[json]]) {
    const message = JSON.parse(json) as Mutable<Command>
    let hide = false
    const store = ctx.getState()
    const forAutoAnswer = getForAutoAnswer(store)

    commandReceived(message)

    message.Time = getNow(store)
    message.Hide = false

    //get dsl key
    const id = getCommandIdFromCommand(message)
    const callId = message.ExtendedInfo.QueueItems ? message.ExtendedInfo.QueueItems.Key : '';

    if (message.CommandType !== 'SHUTDOWN' && forAutoAnswer.findIndex(x => x === callId) !== -1) {
      ctx.dispatch(actions.ccRemoveForAutoAnswer(callId))
      hide = true
    }

    await ctx.dispatch(actions.updateMediaCommand({ ...message, Hide: hide }))

    if (hide) {
      //need to wait for the media to be ringing at my extension too
      await waitForState(ctx, s => {
        const media = selectMyMedia(s)
        return media.findIndex(m => m.id === callId && m.status === CallState.ExtensionPending) !== -1
      })

      ctx.dispatch(actions.acceptCommand(id, callId))
    }
  },


  [MessageType.BROADCAST_STATIC_DIRECTORY_UPDATE]({ dispatch, getState }, [[, json]]) {
    //2089
    // need to update the logged in user details and devices
    const message = JSON.parse(json) as RawStaticDirectory

    const store = getState()
    const me = selectMyself(store)

    if (!me) return

    const server = message.ServerKey === "" ? me.server : message.ServerKey;
    dispatch(actions.updateStaticData({ id: message.ExtensionNumber, server: server }, message.FirstName, message.LastName, message.OfficeExtension, message.OtherNumber, message.Mobile, message.HomeNumber, message.AssociateNumber, message.RegionId, message.Email, message.Devices.map(device => ({
      number: device.Number.toLowerCase(),
      baseType: device.BaseType,
      deviceSubType: device.BaseSubType,
      canReceiveVm: device.CanReceiveVoiceMail,
      tenant: device.Tenant,
      pbxActionBitMask: device.PbxActionBitMask,
      description: device.Description,
    })),
      message.ExtendedAvailablePresence === null ? false : message.ExtendedAvailablePresence,
      message.ShowInDirectory === null ? false : message.ShowInDirectory))

    if (me.server === message.ServerName && me.id === message.ExtensionNumber) {
      const deviceGroup = selectCurrentDeviceGroup(store)
      const devices = selectMyDevices(store)
      if (devices === null) return

      let number = me.id

      if (deviceGroup !== null) {
        switch (deviceGroup.playBackDevice) {
          case DeviceGroupDestinationTypes.Other:
            number = message.OtherNumber;
            break;
          case DeviceGroupDestinationTypes.MobilePhone:
            number = message.Mobile;
            break;
          case DeviceGroupDestinationTypes.Home:
            number = message.HomeNumber;
            break;
          case DeviceGroupDestinationTypes.Softphone:
            if (devices != null) {
              for (let x = 0; x < devices.devices.length; x++) {
                if (devices.devices[x].baseType === DeviceType.Softphone) {
                  number = devices.devices[x].number;
                  x = devices.devices.length
                }
              }
            }
            break;
          case DeviceGroupDestinationTypes.Office:
          default:
            {
              number = me.id;
            }
        }
      }

      //sometimes there is no number set on device group
      if (number === "") {
        number = me.id
      }

      for (let x = 0; x < devices.devices.length; x++) {
        if (devices.devices[x].number === number) {
          dispatch(actions.updatePrimaryDevice(number))
        }
      }
    }
  },

  async [MessageType.RESPONSE_STARTUP_VM_MC_TOASTER](ctx, [[extension], [missed], vm]) {
    ctx.dispatch(actions.updateMissedCallsCount(parseInt(missed)))
    await onVmUnread(ctx, vm)
  },

  async [MessageType.BROADCAST_VM_INBOXCOUNT](ctx, [[count], vm]) {
    await onVmUnread(ctx, vm)
  },

  [MessageType.BROADCAST_VM_CLIENTPORT]({ dispatch, getState }, [[voicemailPort, extension, connected]]) {
    const store = getState()
    const call = selectMyActiveCall(store)
    const me = selectMyself(store)
    //if myself and have the call
    if (call !== null && me && me.id === extension) {
      dispatch(actions.updateMediaRecording(call.id, voicemailPort, connected === "1"))
    }
  },

  [MessageType.BROADCAST_VM_MSG_UPDATE]({ dispatch, getState }, [[shortName, messageType, status, priority, forwardType, date, person, subject, , number, id, folder, server, duration, extension]]) {
    const d = dayjs(parseStringDate(date))
    if (!d) return

    dispatch(actions.updateVmMessage({ id: extension, server }, id, shortName, parseInt(messageType), parseInt(status), priority !== '1', d.add(d.utcOffset(), 'minute').valueOf(), parseInt(forwardType) === 4, subject, parseInt(duration), number, convertMailboxEnum(folder), person))
  },

  [MessageType.BROADCAST_VM_MSG_DELETE]({ dispatch, getState }, [[id, , folder, extension, server]]) {
    dispatch(actions.deleteVoiceMail({ id: extension, server }, id, convertMailboxEnum(folder)))
  },

  [MessageType.RESPONSE_MISCALLS_COUNT]({ dispatch }, [[count], vm]) {
    dispatch(actions.updateMissedCallsCount(parseInt(count)))
  },

  [MessageType.RESPONSE_CH_UPDATE_EVENT]({ dispatch }, [[type, clid, clidDescription, dateTimeStartUtc, deviceType, read, id, duration, device, deviceDescription, subject, mediaType, callKey, mediaItemId, queueId, queue]]) {
    const folder: CallFolder | null =
      type === '0' ? 'missed' :
        type === '1' ? 'received' :
          type === '2' ? 'placed' :
            null

    if (folder) {
      const date = dayjs(parseStringDate(dateTimeStartUtc))

      const history = {
        id: id,
        from: {
          id: clid,
          name: clidDescription,
        },
        folder,
        subject: subject,
        date: date.add(date.utcOffset(), 'minute').valueOf(),
        duration: parseInt(duration),
        read: read === '1',
        mediaType: mediaType,
        deviceType: parseInt(deviceType),
        callKey: callKey,
        mediaItemId: mediaItemId,
        queueId: queueId,
        queue: queue,
      } as Call

      dispatch(actions.updateCallHistory(folder, history))
    }
  },
  [MessageType.RESPONSE_CH_DELETE_EVENT]({ dispatch }, [[type, id]]) {
    const folder: CallFolder | null =
      type === '0' ? 'missed' :
        type === '1' ? 'received' :
          type === '2' ? 'placed' :
            null

    if (folder) {
      dispatch(actions.deleteCallHistory(folder, id))
    }
  },
  async [MessageType.BROADCAST_DB_UPDATE]({ dispatch, getState }, [[json]]) {
    const store = getState()
    const myId = selectMyself(store)
    const featureClassId = selectConfigProp(store, 'featureClassId')
    const raw = JSON.parse(json)
    const update = getDbUpdate(raw)

    if (!myId || featureClassId === undefined) return

    if (update.table === 'Teams') {
      if (update.action === DBAction.Delete) {
        //delete squad by ID
        dispatch(actions.deleteSquad({ id: update.rows[0].ID, server: update.server }))
      }
      else if (update.action === DBAction.Update) {
        dispatch(actions.updateSquad({ id: update.rows[0].ID, server: update.server, description: update.rows[0].Description, type: "squad" }))
      }
      else if (update.action === DBAction.Create) {
        dispatch(actions.addSquad({ id: update.rows[0].ID, server: update.server, description: update.rows[0].Description, type: "squad"}))
      }
      
    } else if (update.table === 'TeamExtensions') {
      let ids: SquadId[] = []
      if (update.action === DBAction.Delete) {
        for (const row of update.rows) {
          ids.push({ id: row.TeamID, server: update.server } as SquadId)
        }
      } else if (update.action === DBAction.Create || update.action === DBAction.Update) {
        for (const row of update.rows) {
          ids.push({ id: row.TeamID, server: update.server } as SquadId)
        }
      }

      const items = Array.from(new Set([...ids]))  //unquie ids
      //need to do this on a timer
      items.forEach(id => {
        dispatch(actions.fetchSquadAgents(id))
        dispatch(actions.fetchSquadMedia(id))
      });


    } else if (update.table === 'Extension') {
      //ID¤Tenant¤Type¤Firstname¤Lastname¤Title¤Position¤WrapupTime¤UserLevel¤SecurityCode¤Email¤Location¤StartTime¤ReturnTime¤Notes¤RecordInbound¤RecordOutbound¤RecordUCD¤Department¤InDirectory¤CallbackEnabled¤PersonalQueuePriority¤PersonalQueueEnabled¤Register¤LCDName¤WrapupValue¤CanReceiveVM¤TollClassID¤FeatureClassID¤CallForwardBusy¤CallForwardNoAnswer¤CallForwardAll¤CallForwardNoAnswerTimeout¤CallForwardOnFailure¤RegionID¤AutoAnswer¤BusinessStartTime¤BusinessEndTime¤AutoAnswerDelay¤MacAddress¤ImagePath¤ImageDate¤OutboundDDIType¤OutboundDDINumber¤ForeignKey¤SystemExtension¤SubLocationID¤SyncOCS¤CurrentDeviceGroupId¤DefaultDeviceGroupId¤Manager¤ExtendedAvailablePresence¤PreferredRegionID¤ScreenCapture¤WinLogonID¤MobileNumberVisible¤HomeNumberVisible¤OtherNumberVisible¤
      if (update.action === DBAction.Delete) {
        for (const row of update.rows) {
          dispatch(actions.deleteExtension({ id: row.ID, server: update.server }))
        }
      } else if (update.action === DBAction.Create || update.action === DBAction.Update) {
        for (const row of update.rows) {
          dispatch(actions.updateExtensionTable({ id: row.ID, server: update.server }, parseInt(row.Tenant), parseInt(row.Type), row.Firstname, row.Lastname, row.Title, row.Position, parseInt(row.WrapupTime), parseInt(row.UserLevel), row.SecurityCode, row.Email, parseInt(row.Location), row.StartTime, row.ReturnTime, row.Notes, row.RecordInbound === '1', row.RecordOutbound === '1', row.RecordUCD === '1', row.Department, row.InDirectory === '1', row.CallbackEnabled === '1', row.PersonalQueuePriority, row.PersonalQueueEnabled === '1', row.Register === '1', row.LCDName, parseInt(row.WrapupValue), row.CanReceiveVM === '1', parseInt(row.TollClassID), parseInt(row.FeatureClassID), row.CallForwardBusy, row.CallForwardNoAnswer, row.CallForwardAll, parseInt(row.CallForwardNoAnswerTimeout), row.CallForwardOnFailure, row.RegionID, parseInt(row.AutoAnswer), row.BusinessStartTime, row.BusinessEndTime, parseInt(row.AutoAnswerDelay), row.MacAddress, row.ImagePath, row.ImageDate, parseInt(row.OutboundDDIType), row.OutboundDDINumber, row.ForeignKey, row.SystemExtension === '1', parseInt(row.SubLocationID), row.SyncOCS === '1', row.CurrentDeviceGroupId, row.DefaultDeviceGroupId, row.Manager, row.ExtendedAvailablePresence === '1', row.PreferredRegionID, parseInt(row.ScreenCapture), row.WinLogonID, row.MobileNumberVisible === '1', row.HomeNumberVisible === '1', row.OtherNumberVisible === '1'))

          if (myId.id === row.ID && myId.server === update.server) {
            if (featureClassId !== parseInt(row.FeatureClassID))  // FeatureClassID instead of featureClassId because this is the raw db column name.
              dispatch(actions.showClientNotification('Your user level has been changed.  Restart your client.', false))
          }
        }
      }
    } else if (update.table === 'tblContacts') {
      if (update.action === DBAction.Delete) {
        for (const row of update.rows) {
          dispatch(actions.deleteContact('', { id: row.ContactID, server: update.server }))
        }
      } else if (update.action === DBAction.Create || update.action === DBAction.Update) {
        for (const row of update.rows) {
          dispatch(actions.updateContactDetails(update.server, parseInt(row.ContactID), row.RegionID, row.Extension, row.Description, row.Email))
        }
      }
    } else if (update.table === 'tblContactNumbers') {
      if (update.action === DBAction.Delete) {
        for (const row of update.rows) {
          dispatch(actions.deleteContactNumber(update.server, parseInt(row.ContactID), parseInt(row.ContactNumberType)))
        }
      } else if (update.action === DBAction.Create || update.action === DBAction.Update) {
        for (const row of update.rows) {
          dispatch(actions.updateContactNumber(update.server, parseInt(row.ContactID), parseInt(row.ContactNumberType), row.ContactNumber))
        }
      }
    }
    else if (update.table === 'tblTaskEmail') {
      const media = selectMyMedia(store)
      for (const row of update.rows) {
        media.forEach(m => {
          if (compareGuidId(m.taskId, row.TaskId)) {
            dispatch(actions.fetchMediaTaskItemsRequest(m.id, row.TaskId))
          }
        })
      }
    }
    else if (update.table === 'tblGroupLists') {
      const myId = selectMyself(getState())
      const favQueueFolderId = selectFavQueueFolderId(getState())
      const favContactFolderId = selectFavContactFolderId(getState())
      const favExtensionFolderId = selectFavExtensionFolderId(getState())
      const shortcutFolderId = selectShortcutFolderId(getState())

      if (!favQueueFolderId || !favContactFolderId || !favExtensionFolderId || !shortcutFolderId || !myId) return

      for (const row of update.rows) {
        if (row.Extension === myId.id) {
          if (row.ParentID === favExtensionFolderId) {
            dispatch(actions.favouriteExtensionAction({ id: row.ObjectID, server: row.ServerID }, (update.action === DBAction.Create || update.action === DBAction.Update), favExtensionFolderId))
          } else if (row.ParentID === favExtensionFolderId) {
            dispatch(actions.favouriteContactAction({ id: row.ObjectID, server: row.ServerID }, (update.action === DBAction.Create || update.action === DBAction.Update), favExtensionFolderId))
          } else if (row.ParentID === favQueueFolderId) {
            dispatch(actions.favouriteQueueAction({ id: row.ObjectID, server: row.ServerID }, (update.action === DBAction.Create || update.action === DBAction.Update), favExtensionFolderId))

          } else if (row.ParentID === shortcutFolderId) {
            //cleanup group list id
            const groupListId = row.GroupListID.toLowerCase().replace('{', '').replace('}', '')
            const entityType: EntityType = parseInt(row.ObjectType)
            if (update.action === DBAction.Delete) {
              dispatch(actions.shortcutDeleteEntity(groupListId))
            } else {
              const sort = row.NonIdentifyingData ? parseInt(row.NonIdentifyingData) : -1
              const id = { server: row.ServerID, id: row.ObjectID }
              let shortcut: Shortcut | undefined

              switch (entityType) {
                case EntityType.Contact:
                  const c = await getContactsByIds(myId, [id])
                  shortcut = {
                    entityType,
                    sort,
                    groupListId,
                    ...c.rows[0],
                  }
                  break

                case EntityType.Extension:
                  const e = await getExtensionsByIds(myId, [id], 0)
                  shortcut = {
                    entityType,
                    sort,
                    groupListId,
                    ...e.rows[0],
                  }
                  dispatch(actions.fetchExtensionsByIdsResponse(e.rows))
                  break

                case EntityType.Queue:
                  const q = await apiQueue.getQueuesByIds(myId, [id])
                  shortcut = {
                    entityType,
                    sort,
                    groupListId,
                    ...q[0],
                  }
                  break
              }

              if (shortcut) {
                dispatch(actions.shortcutUpdateEntity(shortcut))
              }
            }
          }
        }
      }
    } else if (update.table === 'tblMQFacebookComment') {
      for (const row of update.rows) {
        let facebook = selectFacebookByPostId(store, row.PostId)

        if (facebook) {
          const p = facebook.posts.find(p => p.postId === row.PostId)

          if (p) {
            let post: FacebookPost
            let comment: FacebookComment
            let comments: FacebookComment[] = []
            let replys: FacebookComment[] = []

            if (row.ParentCommentId === '') {
              const iComment = p.comments.findIndex(c => c.commentId === row.CommentId)

              if (iComment !== -1) {
                replys = p.comments[iComment].replies
              }

              const date = dayjs(parseStringDate(row.CreatedAtUtc))

              comment = {
                commentId: row.CommentId,
                createdAtUtc: date.add(date.utcOffset(), 'minute').valueOf(),
                userId: row.UserId,
                userName: '',
                text: row.Text,
                postId: row.PostId,
                parentCommentId: row.ParentCommentId,
                unRead: row.UnRead === '1',
                extensionId: row.ExtensionId,
                attachmentType: row.AttachmentType,
                attachmentUrl: row.AttachmentUrl,
                attachmentTitle: row.AttachmentTitle,
                attachmentDescription: row.AttachmentDescription,
                attachmentImage: row.AttachmentImage,
                replies: replys,
              } as FacebookComment

              comments = iComment === -1 ? [comment, ...p.comments] : [...p.comments.slice(0, iComment), comment, ...p.comments.slice(iComment + 1)]
            }
            else {
              const iComment = p.comments.findIndex(c => c.commentId === row.ParentCommentId)
              const c = p.comments.find(c => c.commentId === row.ParentCommentId)
              if (iComment === -1 || !c) {
                return
              }

              const iReplys = c.replies.findIndex(x => x.commentId === row.CommentId)

              const date = dayjs(parseStringDate(row.CreatedAtUtc))

              const reply = {
                commentId: row.CommentId,
                createdAtUtc: date.add(date.utcOffset(), 'minute').valueOf(),
                userId: row.UserId,
                userName: '',
                text: row.Text,
                postId: row.PostId,
                parentCommentId: row.ParentCommentId,
                unRead: row.UnRead === '1',
                extensionId: row.ExtensionId,
                attachmentType: row.AttachmentType,
                attachmentUrl: row.AttachmentUrl,
                attachmentTitle: row.AttachmentTitle,
                attachmentDescription: row.AttachmentDescription,
                attachmentImage: row.AttachmentImage,
                replies: replys,
              } as FacebookComment

              replys = iReplys === -1 ? [reply, ...c.replies] : [...c.replies.slice(0, iReplys), reply, ...c.replies.slice(iReplys + 1)]

              comment = {
                commentId: c.commentId,
                createdAtUtc: c.createdAtUtc,
                userId: c.userId,
                userName: c.userName,
                text: c.text,
                postId: c.postId,
                parentCommentId: c.parentCommentId,
                unRead: c.unRead,
                extensionId: c.extensionId,
                attachmentType: c.attachmentType,
                attachmentUrl: c.attachmentUrl,
                attachmentTitle: c.attachmentTitle,
                attachmentDescription: c.attachmentDescription,
                attachmentImage: c.attachmentImage,
                replies: replys,
              } as FacebookComment

              comments = [...p.comments.slice(0, iComment), comment, ...p.comments.slice(iComment + 1)]
            }

            post = {
              postId: p.postId,
              createdAtUtc: p.createdAtUtc,
              type: p.type,
              userId: p.userId,
              userName: p.userName,
              text: p.text,
              linkUrl: p.linkUrl,
              linkPicture: p.linkPicture,
              linkName: p.linkName,
              linkCaption: p.linkCaption,
              linkDescription: p.linkDescription,
              linkTitle: p.linkTitle,
              pageId: p.pageId,
              unRead: p.unRead,
              comments: comments,
            } as FacebookPost

            dispatch(actions.updateFacebookPost(facebook.key, post))
          }
        }
      }
    } else if (update.table === 'tblMQFacebookPost') {
      for (const row of update.rows) {
        //find existing facebook
        let facebook = selectFacebookByPostId(store, row.PostId)
        if (!facebook) {
          //if not there then look via page and user
          facebook = selectFacebookByUserId(store, row.UserId, row.PageId)
        }

        if (facebook) {
          const p = facebook.posts.find(p => p.postId === row.PostId)
          const date = dayjs(parseStringDate(row.CreatedAtUtc))
          const post =
            {
              postId: row.PostId,
              createdAtUtc: date.add(date.utcOffset(), 'minute').valueOf(),
              type: row.Type,
              userId: row.UserId,
              userName: '',
              text: row.Text,
              linkUrl: row.LinkUrl,
              linkPicture: row.LinkPicture,
              linkName: row.LinkName,
              linkCaption: row.LinkCaption,
              linkDescription: row.LinkDescription,
              linkTitle: row.LinkTitle,
              pageId: row.PageId,
              unRead: row.UnRead === '1',
              comments: p ? p.comments : [],
            } as FacebookPost

          dispatch(actions.updateFacebookPost(facebook.key, post))
        }
      }
    }
  },

  [MessageType.BroadcastAgentStats]({ dispatch }, [[json]]) {
    const raw = parseJson<AgentStatistic>(json)
    dispatch(actions.loadAgentStats(raw.extensionId, raw))
  },

  [MessageType.RESPONSE_EXTENSIONSTATE_CALLBACK_EVENT]({ dispatch, getState }, [[server, extension]]) {
    const state = getState()
    if (selectHaveCallback(state, extension)) {
      dispatch(actions.setCallback(extension, false))

      const contact = selectExtension(state, { id: extension, server })
      const name = contact ? contact.name : extension
      const device = selectActiveDevice(state)
      //proably should check you phone state
      showConfirmWindow("Extension Callback", `Would you still like to call '${name}'?`, (action: string) => {
        if (action === "yes" && device) {
          dispatch(actions.ccDial(extension))
        }
      })
    }
  },
  [MessageType.BROADCAST_IM_ONUNREADCOUNT]({ dispatch }, [[normalUnreadCount, urgentUnreadCount]]) {
    dispatch(actions.instantMessagerUnreadCount(parseInt(normalUnreadCount), parseInt(urgentUnreadCount)))
  },
  [MessageType.BROADCAST_IM_ONTOASTERPOP]({ dispatch }, [[conversationId, unread, urgent, message, title, blocked]]) {
    dispatch(actions.instantMessagerToaster(conversationId, parseInt(unread), urgent === '1', message, title, blocked === '1'))
  },
  async [MessageType.BROADCAST_IM_CONVERSATIONJOIN]({ dispatch }, [[userData, json]]) {

    const data = parseJson<RawInstantMessageConversation>(json)
    await proccessInstantMessagerConversation(dispatch, MessageType.BROADCAST_IM_CONVERSATIONJOIN, data, false, userData)

    console.info('BROADCAST_IM_CONVERSATIONJOIN [' + userData + '] - ' + data.conversationId)

    dispatch(actions.changeInstantmessageView(data.conversationId))
  },
  async [MessageType.BROADCAST_IM_ENDPOINTCONVERSATIONADDED]({ dispatch }, [[conversationId, json]]) {
    await proccessInstantMessagerConversation(dispatch, MessageType.BROADCAST_IM_ENDPOINTCONVERSATIONADDED, parseJson<RawInstantMessageConversation>(json), false, "")
  },
  [MessageType.BROADCAST_IM_ENDPOINTCONVERSATIONREMOVED]({ dispatch }, [[, json]]) {
    const data = parseJson<RawInstantMessageConversation>(json)
    dispatch(actions.instantMessagerConversationEndpointRemove(data.conversationId))
  },
  async [MessageType.BROADCAST_IM_ENDPOINTCONVERSATIONUPDATED]({ dispatch, getState }, [[conversationId, json]]) {
    await proccessInstantMessagerConversation(dispatch, MessageType.BROADCAST_IM_ENDPOINTCONVERSATIONUPDATED, parseJson<RawInstantMessageConversation>(json), false, "")
  },
  [MessageType.BROADCAST_IM_CONVERSATIONUPDATED]({ dispatch }, [[conversationId, oneToOneConversation]]) {
    dispatch(actions.instantMessagerConversationOneToOneUpdate(conversationId, oneToOneConversation === '1'))
  },
  [MessageType.BROADCAST_IM_CONVERSATIONMESSAGE]({ dispatch }, [[conversationId, messageId, message]]) {
    dispatch(actions.instantMessagerMessageAdd(conversationId, messageId, message))
  },
  [MessageType.BROADCAST_IM_CONVERSATIONMESSAGEREPLACE]({ dispatch }, [[conversationId, messageId, message]]) {
    dispatch(actions.instantMessagerMessageReplace(conversationId, messageId, message))
  },
  [MessageType.BROADCAST_IM_RECIPIENTSTOPPEDTYPING]({ dispatch }, [[conversationId, participantid]]) {
    dispatch(actions.instantMessagerParticipantTyping(conversationId, participantid, false))
  },
  [MessageType.BROADCAST_IM_RECIPIENTSTARTEDTYPING]({ dispatch }, [[conversationId, participantId]]) {
    dispatch(actions.instantMessagerParticipantTyping(conversationId, participantId, true))
  },
  [MessageType.BROADCAST_IM_RECIPIENTADDED]({ dispatch, getState }, [[conversationId, participantId, endpointScheme, endpointId, endpointServer, displayName, statusToString, status, sendInviteMessagesOnly, state, recordCount]]) {
    const store = getState()
    const conversation = getInstantMessageById(store, conversationId)
    if (!conversation || !conversation.currentUserId) return

    dispatch(actions.instantMessagerParticipantUpdate(conversationId, participantId, parseInt(endpointScheme), endpointId, endpointServer, displayName, parseInt(status), sendInviteMessagesOnly === '1', parseInt(state), conversation.currentUserId === participantId))
  },
  [MessageType.BROADCAST_IM_RECIPIENTSTATUSUPDATED]({ dispatch, getState }, [[conversationId, participantId, endpointScheme, endpointId, endpointServer, displayName, statusToString, status, sendInviteMessagesOnly, state, recordCount]]) {
    const store = getState()
    const conversation = getInstantMessageById(store, conversationId)
    if (!conversation || !conversation.currentUserId) return

    dispatch(actions.instantMessagerParticipantUpdate(conversationId, participantId, parseInt(endpointScheme), endpointId, endpointServer, displayName, parseInt(status), sendInviteMessagesOnly === '1', parseInt(state), conversation.currentUserId === participantId))
  },
  [MessageType.BROADCAST_IM_CONVERSATIONMESSAGEINSERTAFTER]({ dispatch }, [[conversationId, messageId, historyHtml]]) {
    let messages: ConversationMessage[] = []
    historyHtml.split("<div class=\"txt-item").forEach(element => {
      if (element.trim() !== '') {
        const message = "<div class=\"txt-item" + element
        messages.push({ messageId: '', message: message.replace(/txt-item left/g, 'txt-item left-item').replace(/txt-item right/g, 'txt-item right-item') })
      }
    });

    dispatch(actions.instantMessagerMessageHistory(conversationId, messageId, messages))
  },
  [MessageType.BROADCAST_IM_CONVERSATIONTITLEUPDATED]({ dispatch }, [[conversationId, title]]) {
    dispatch(actions.instantMessagerConversationTitleUpdate(conversationId, title))
  },
  [MessageType.BROADCAST_IM_RECIPIENTREMOVED]({ dispatch }, [[conversationId, participantid]]) {
    dispatch(actions.instantMessagerParticipantRemove(conversationId, participantid))
  },
  [MessageType.BROADCAST_IM_RECIPIENTREMOVED]({ dispatch }, [[conversationId, participantid]]) {
    dispatch(actions.instantMessagerParticipantRemove(conversationId, participantid))
  },
  [MessageType.BROADCAST_IM_NONURGENTMESSAGEBLOCKED]({ dispatch }, [[conversationId, participantid, original, message, options, invite]]) {
    //old client loads up "im-suppress-dialog"
  },
  [MessageType.BROADCAST_IM_SETTINGSCHANGED]({ dispatch }, [[imEnabled, imAllowBlockedMessagesSentAsEmails, imBlockMessageInLocation]]) {
    dispatch(actions.instantMessagerSettingsUpdate(imEnabled === '1', imAllowBlockedMessagesSentAsEmails === '1', imBlockMessageInLocation === '1'))
  },
  [MessageType.BROADCAST_IM_SWITCHTOCONVERSATIONUI]({ dispatch }, [[key, conversationId]]) {
    dispatch(actions.changeInstantmessageView(conversationId))
  },
  [MessageType.BroadcastShowPopUpBasic]({ dispatch }, [[json]]) {
    const message = JSON.parse(json) as BroadcastShowPopUpBasic
    dispatch(actions.showServerNotification({ subject: message.Subject, alertBody: message.AlertBody, status: message.Status, imageKey: message.ImageKey, time: getUtcNow() } as BasicNotification))
  },

  [MessageType.BroadcastVmMessageCount]({ dispatch, getState }, [[json]]) {
    const store = getState()
    const myId = selectMyself(store)

    if (!myId) return

    const message = JSON.parse(json) as BroadcastVmMessageCount
    message.Extensions.forEach(counts => {
      dispatch(actions.updateVoicemailCount({ id: counts.Extension, server: myId.server } as Identifier, (counts.NormalUnread + counts.UrgentUnread)))
    })
  },

  [MessageType.RequestOpenbookIt]({ dispatch, getState }, [[json]]) {
    const store = getState()
    const myId = selectMyself(store)
    const config = getConfig(store)
    const electron = selectInIpfxClient(store)

    if (!myId || !config) return

    if (electron) {
      const message = JSON.parse(json) as RequestOpenbookIt

      requestOpenBookItWindow('ack', message.SentFromClientId, config.ipAddress)
      dispatch(actions.requestOpenBookIt())
    }
  },

  [MessageType.ResponseOpenbookIt]({ dispatch, getState }, [[json]]) {
    const store = getState()
    const myId = selectMyself(store)
    const config = getConfig(store)
    const message = JSON.parse(json) as ResponseOpenbookIt

    if (!myId || !config || config.clientId !== message.SentToClientId || config.ipAddress !== message.ClientIp) return

    dispatch(actions.responseOpenBookIt())

  },

  [MessageType.TeamsClientControlExtensionCti]({ dispatch, getState }, [[json]]) {
    const store = getState()
    const myId = selectMyself(store)
    const config = getConfig(store)
    const message = JSON.parse(json) as TeamsClientControlExtensionCti

    if (!myId || !config || myId.id !== message.Extension) return

    if (message.Action === 0) {
      dispatch(actions.setEnhancedIntegration(false))
    } else if (message.Action === TeamsClientControlCtiAction.TeamsClientIntegratedMode) {
      dispatch(actions.setEnhancedIntegration(true))
    }
  },

  [MessageType.NotifyTranscriptionStarted](ctx, [[json]]) {
    const raw = parseJson<NotifyTranscriptionStarted>(json)
    const calls = raw.calls.map(x => {
      const createdAtUtc = dayjs(parseMsDate(x.createdAtUtc))
      const modifiedAtUtc = dayjs(parseMsDate(x.modifiedAtUtc))

      return {
        ...x,
        createdAtUtc: createdAtUtc.add(createdAtUtc.utcOffset(), 'minute').valueOf(),
        modifiedAtUtc: modifiedAtUtc.add(modifiedAtUtc.utcOffset(), 'minute').valueOf(),
      }
    })

    ctx.dispatch(actions.notifyTranscriptionStarted(raw.callKey, raw.transcriptionId, calls))

  },

  [MessageType.NotifyTranscriptionStopped](ctx, [[json]]) {
    const raw = parseJson<NotifyTranscriptionStopped>(json)
    const media = selectMedia(ctx.getState(), raw.callKey)

    if (!media) return
  },

  async [MessageType.NotifySubscriptionExpiring](ctx, [[json]]) {
    const raw = parseJson<NotifySubscriptionExpiring>(json)
    const transcription = getTranscriptions(ctx.getState(), raw.callKey)

    if (!transcription) {
      await callTranscriptionUnSubscribe(raw.callKey)
    } else {

      const response = await callTranscriptionValidate(raw.callKey)

      if (!response.success || response.data !== "0") {
        ctx.dispatch(actions.closeClientNotification('Validation of transcription subscription failed.'))
      }
    }
  },

  async [MessageType.NotifyParagraphTextChanged](ctx, [[json]]) {
    const raw = parseJson<NotifyParagraphTextChanged>(json)
    const media = selectMedia(ctx.getState(), raw.callKey)
    const transcription = getTranscriptions(ctx.getState(), raw.callKey)

    if (!transcription) return

    let call = transcription.calls.find(x => x.callId.toString() === raw.callId.toString())
    //go get call data if we don't have it
    if (!call) {
      call = await getCallTranscriptionCall(raw.callKey, raw.callId, media !== undefined)
      //update store
      if (call) {
        ctx.dispatch(actions.fetchCallTranscriptionCallResponse(raw.callKey, call))
      }
    }

    const createdAtUtc = dayjs(parseMsDate(raw.createdAt))
    const modifiedAtUtc = dayjs(parseMsDate(raw.modifiedAt))

    ctx.dispatch(actions.notifyTranscriptionParagraphUpdated(raw.callKey, raw.transcriptionId,
      raw.paragraphId,
      raw.callId,
      createdAtUtc.valueOf(),
      modifiedAtUtc.valueOf(),
      raw.modifiedBy,
      raw.text,
      raw.canEdit,
      call,
    ))
  },

  [MessageType.NotifyParagraphSentimentScoreChanged]({ dispatch, getState }, [[json]]) {
    const raw = parseJson<NotifyParagraphSentimentScoreChanged>(json)
    const modifiedAtUtc = dayjs(parseMsDate(raw.modifiedAt))
    dispatch(actions.notifySentimentParagraph(raw.callKey, raw.transcriptionId, raw.paragraphId, raw.score.sentiment, raw.modifiedBy, modifiedAtUtc.valueOf(), raw.score.neutral, raw.score.negative, raw.score.positive))
  },

  [MessageType.NotifyDatastoreCallSentimentScoreChanged]({ dispatch, getState }, [[json]]) {
    const raw = parseJson<NotifyDatastoreCallSentimentScoreChanged>(json)
    dispatch(actions.notifySentimentCall(raw.callKey, raw.score.sentiment, raw.modifiedBy, raw.score.neutral, raw.score.negative, raw.score.positive))
  },

  [MessageType.BroadcastBookmarkCreated]({ dispatch, getState }, [[json]]) {
    const raw = parseJson<BroadcastBookmarkCreated>(json)
    const timeStamp = dayjs(parseMsDate(raw.bookmark.timeStamp))
    const createdAt = dayjs(parseMsDate(raw.bookmark.createdAt))
    const modifiedAt = dayjs(parseMsDate(raw.bookmark.modifiedAt))

    dispatch(actions.createCallTranscriptionTag(raw.callKey, raw.bookmark.bookmarkId, raw.bookmark.title, timeStamp.valueOf(), raw.bookmark.bookmarkTypeId, raw.bookmark.createdBy, createdAt.valueOf(), raw.bookmark.modifiedBy, modifiedAt.valueOf()))
  },

  [MessageType.BroadcastBookmarkDeleted]({ dispatch, getState }, [[json]]) {
    const raw = parseJson<BroadcastBookmarkDeleted>(json)
    dispatch(actions.deleteCallTranscriptionTag(raw.callKey, raw.bookmarkId))
  },

  [MessageType.BroadcastBookmarkRenamed]({ dispatch, getState }, [[json]]) {
    const raw = parseJson<BroadcastBookmarkRenamed>(json)
    const modifiedAt = dayjs(parseMsDate(raw.modifiedAt))
    dispatch(actions.renamedCallTranscriptionTag(raw.callKey, raw.bookmarkId, raw.title, raw.modifiedBy, modifiedAt.valueOf()))
  },

  [MessageType.BroadcastBookmarkMoved]({ dispatch, getState }, [[json]]) {
    const raw = parseJson<BroadcastBookmarkMoved>(json)
    const timeStamp = dayjs(parseMsDate(raw.timeStamp))
    const modifiedAt = dayjs(parseMsDate(raw.modifiedAt))
    dispatch(actions.movedCallTranscriptionTag(raw.callKey, raw.bookmarkId, timeStamp.valueOf(), raw.modifiedBy, modifiedAt.valueOf()))
  },

  [MessageType.ResponseConference]({ dispatch, getState }) {
    teamsShowJoinConferenceDialog()
  },

  [MessageType.ResponseJitsiJoin]({ dispatch, getState }, [[json]]) {
    const raw = parseJson<ResponseJitsiJoin>(json)
    dispatch(actions.responseJitsiStart(raw.jitsiId, raw.accept ? JitsiResult.Accept : JitsiResult.Decline))
  },
  async [MessageType.RequestJitsiJoin](ctx, [[json]]) {
    const store = ctx.getState()
    const raw = parseJson<RequestJitsiJoin>(json)
    const myId = selectMyself(store)
    const devices = selectMyDevices(store)
    const myExtension = myId && selectExtension(store, myId)
    const http = document.location.href.substr(0, document.location.href.toLocaleLowerCase().indexOf('teams'))

    if (!myId || !myExtension || !devices) return

    const id = { id: raw.from, server: myId.server }
    let extension = selectExtension(store, id)
    if (!extension) {
      ctx.dispatch(actions.fetchExtensionsByIds([id]))
      extension = await waitForState(ctx, s => selectExtension(s, id))
    }

    if (!extension) return

    const name = (extension === undefined) ? 'Unkown' : extension.name

    showConfirmWindow('Video Conference Request', '\'' + extension.name + '\' wants to start a video conference.\n Do you accept?', async (action: string) => {
      if (action === "yes") {
        await createJitsiCallResponse(raw.jitsiId, raw.from, JitsiResult.Accept)

        //start video call
        window.open(http + '/jitsi?meetingId=' + raw.jitsiId + '&displayName=' + name + '&showPreJoin=false');

      } else if (action === "no") {
        await createJitsiCallResponse(raw.jitsiId, raw.from, JitsiResult.Decline)
      }
    }, 10)
  },
}

async function proccessInstantMessagerConversation(dispatch: Dispatch<AnyAction>, messageId: MessageType, data: RawInstantMessageConversation, joined: boolean, userData: string) {
  const createdUtc = data.createdUtc ? parseMsDate(data.createdUtc) : undefined
  const lastUpdatedUtc = data.lastUpdatedUtc ? parseMsDate(data.lastUpdatedUtc) : undefined
  const removedFromConversationTimestampUtc = data.removedFromConversationTimestampUtc ? parseMsDate(data.removedFromConversationTimestampUtc) : undefined
  console.log(`moop ${MessageType[messageId]} to process`, data)
  await dispatch(actions.instantMessagerConversationUpdate(messageId,
    {
      conversationId: data.conversationId,
      conversationTitle: data.conversationTitle,
      createdUtc,
      lastUpdatedUtc,
      conversationFlags: data.conversationFlags,
      deviceEndpoint: data.deviceEndpoint,
      createdStoreDateUtc: lastUpdatedUtc ? lastUpdatedUtc : getUtcNow(),
      unreadMessagesTotal: data.unreadMessagesTotal,
      unreadUrgentMessagesTotal: data.unreadUrgentMessagesTotal,
      lastUnreadMessage: data.lastUnreadMessage,
      removedFromConversationTitle: data.removedFromConversationTitle,
      removedFromConversationTimestampUtc,
      recipients: messageId !== MessageType.BROADCAST_IM_CONVERSATIONJOIN ? data.recipients : [],
      participants: messageId === MessageType.BROADCAST_IM_CONVERSATIONJOIN ? data.participants : [],
      currentUserId: data.currentUserId,
      oneToOneConversation: data.oneToOneConversation,
      conversationViewOnly: data.conversationViewOnly,
      joined: joined ? InstantMessagerJoinState.joined : InstantMessagerJoinState.none,
      userData,
    },
  ))
}

// this is the message model from the wire. It's actually two message mangled together :(
export type RawInstantMessageConversation = Readonly<{
  conversationId: string
  conversationTitle: string
  createdUtc: string
  lastUpdatedUtc: string
  conversationFlags: ConversationFlags
  deviceEndpoint: string
  unreadMessagesTotal: number
  unreadUrgentMessagesTotal: number
  lastUnreadMessage: string
  removedFromConversationTitle: string
  removedFromConversationTimestampUtc?: string
  participants: InstantMessageConversationParticipant[]
  currentUserId?: string
  oneToOneConversation?: boolean
  conversationViewOnly?: boolean
  recipients: InstantMessageConversationRecipent[]
}>

async function onVmUnread(ctx: SagaContext<StoreState>, [unread, priority, forwardType, number, name, date]: string[]) {
  const me = await waitForState(ctx, selectMyself)
  ctx.dispatch(actions.updateVmUnreadCount(me, parseInt(unread)))
}

export default async function runPushUpdates(ctx: SagaContext<StoreState>) {
  run(ctx, () => {
    //socket closed, lets reset in 2 seconds so server can cleanup
    setTimeout(() => {
      ctx.dispatch(actions.socketClosed())
    }, 2000);
  })
}

async function run(ctx: SagaContext<StoreState>, onClose: () => void) {
  const config = await waitForState(ctx, getConfig)
  const parked = getParkedMedia(ctx.getState())
  const mobility = selectInIpfxMobility(ctx.getState())
  const cancel = createPromiseSource<false>()

  const closeSocket = pushUpdates(config, mobility, async ({ type, records }) => {
    const handler = Handlers[type]
    if (handler) {
      await handler(ctx, records)
    }
  }, parked, () => {
    cancel.resolve(false)
    onClose()
  })

  const result = await Promise.race([take(ctx, actions.pongFailed), cancel.promise])
  if (result) {
    closeSocket()
  }
}


interface QueueUpdate {
  icon: QueueIconEnum
  id: string
  server: string
  description: string
  mode: QueueMode
  status: string
  count: number
  time: number | null
  agents: number
  answer: number
  abandoned: number
  other: number
  agentStatus: number
  virtual: boolean
  ansQTimeTotal: number
  abnQTimeTotal: number
}


interface ResponseJitsiJoin {
  jitsiId: string
  from: string
  accept: boolean
}

interface RequestJitsiJoin {
  jitsiId: string
  from: string
}

interface TeamsClientControlExtensionCti {
  Extension: string
  Action: TeamsClientControlCtiAction
}


interface ResponseOpenbookIt {
  Header: { ClientId: string }
  SentToClientId: string
  ClientIp: string
}

interface RequestOpenbookIt {
  Header: { ClientId: string }
  SentFromClientId: string
}

interface BroadcastVmMessageCount {
  Extensions: BroadcastVmMessageExtension[]
}

interface BroadcastVmMessageExtension {
  Extension: string
  UrgentUnread: number
  NormalUnread: number
  NormalRead: number
}

interface BroadcastShowPopUpBasic {
  Subject: string
  AlertBody: string
  Status: string
  ImageKey: number
}

interface BroadcastQueueExtensionRemove {
  header: {
    from: {
      remoteServerName: string,
    },
  },
  extensionNumber: string
  queueId: string
}

interface RawDbUpdate {
  Header: {
    To: {
      ComputerName: string,
      Application: string,
    },
    From: {
      ComputerName: string,
      Application: string,
    },
    TransactionId: string,
  },
  TableName: string
  Action: DBAction
  Columns: string[]
  Rows: { Data: Record<string, { Item1: string }> }[]
}

function getDbUpdate(raw: RawDbUpdate) {
  return {
    server: raw.Header.From.ComputerName,
    table: raw.TableName,
    action: raw.Action,
    rows: raw.Rows.map(row => toObject(
      Object.keys(row.Data).map((key, ind) => ({ key, ind })),
      ({ key, ind }) => raw.Columns[ind],
      ({ key }) => row.Data[key].Item1,
    )),
  }
}

interface RawBroadcastCallNoteUpdated {
  CallId: string
  Notes: string
}

interface RawStaticExtensionDevice {
  Number: string
  BaseType: number
  BaseSubType: number
  CanReceiveVoiceMail: boolean
  Tenant: number
  PbxActionBitMask: number
  Description: string
}

interface RawStaticDirectory {
  ExtensionNumber: string
  ServerKey: string
  ServerName: string
  Title: string
  FirstName: string
  LastName: string
  OfficeExtension: string
  Mobile: string
  HomeNumber: string
  PagerNumber: string
  AssociateNumber: string
  BusinessNumber: string
  Email: string
  DepartmentId: string
  ObjectType: number | null
  CallCenterAgent: boolean | null
  RegionId: string
  CanReceiveVoiceMail: boolean | null
  ShowInDirectory: boolean | null
  OperatorMessage: string
  OtherNumber: string
  DefaultDeviceGroupId: string | null
  CurrentDeviceGroupId: string | null
  Manager: string
  PresenceStartTime: Date | null
  DeviceBitMask: number | null
  CurrentDeviceGroupType: number | null
  ExtendedAvailablePresence: boolean | null
  Notes: string
  ScreenCapture: number
  IsMobileNumberVisible: boolean
  IsHomeNumberVisible: boolean
  IsOtherNumberVisible: boolean
  Devices: RawStaticExtensionDevice[]
}

interface RawNotifyUpsertedActivity {
  header: {
    from: {
      remoteServerName: string,
    },
  },
  activity: {
    extension: string,
    activityId: string,
  }
}

interface RawNotifyDeletedActivity {
  header: {
    from: {
      remoteServerName: string,
    },
  },
  extension: string,
  activityId: string,
}

interface NotifySubscriptionExpiring {
  callKey: string
}

interface NotifyTranscriptionStopped {
  callKey: string
  transcriptionId: string
  stoppedAtUtc: string,
}

interface NotifyTranscriptionStarted {
  callKey: string
  transcriptionId: string
  createdAtUtc: string,
  calls: TranscriptionCallRaw[]
}

interface NotifyParagraphSentimentScoreChanged {
  modifiedAt: string
  modifiedBy: string
  callKey: string
  transcriptionId: string
  paragraphId: string
  score: {
    sentiment: number,
    positive: number,
    negative: number,
    neutral: number,
  }
}

interface NotifyDatastoreCallSentimentScoreChanged {
  modifiedBy: string
  callKey: string
  score: {
    sentiment: number,
    positive: number,
    negative: number,
    neutral: number,
  }
}

interface NotifyParagraphTextChanged extends TranscriptionParagraphRaw {
  callKey: string
  transcriptionId: string
  createdAt: string,
  modifiedAt: string
}

interface BroadcastBookmarkCreated {
  callKey: string
  bookmark: CallBookmarkRaw
}

interface BroadcastBookmarkDeleted {
  callKey: string
  bookmarkId: string
}

interface BroadcastBookmarkRenamed {
  callKey: string
  bookmarkId: string
  title: string
  modifiedBy: string
  modifiedAt: string
}

interface BroadcastBookmarkMoved {
  callKey: string
  bookmarkId: string
  timeStamp: string
  modifiedBy: string
  modifiedAt: string
}

function convertMailboxEnum(mailbox: string): VoiceMailFolder {
  switch (mailbox) {
    case '3':
      return 'Saved'
    case '4':
      return 'Deleted'

    case '5':
      return 'Sent'

    case '6':
      return 'Future'
    case '0':
    case '1':
    case '2':
    default:
      return 'Inbox'
  }
}

function compareGuidId(a: string, b: string) {
  return a.replace('{', '').replace('}', '').toUpperCase() === b.replace('{', '').replace('}', '').toUpperCase()
}
